import { Text, Flex, Button } from '@revenuemarket/cds';
import { ModalProps } from 'antd';

import CommonModal from './CommonModal';

interface EditConfirmModalProps extends ModalProps {
  isOpen: boolean;
  onExit: () => void;
  onConfirm?: () => void;
}

const EditConfirmModal = ({ isOpen, onExit, onConfirm, onCancel }: EditConfirmModalProps) => {
  return (
    <CommonModal
      title={<Text textStyle="16_600">변경사항을 저장하지 않고 나가시겠습니까?</Text>}
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      centered
      closable
      width={400}
    >
      <Flex direction="column" gap={16} style={{ marginTop: 8 }}>
        <Text textStyle="14_400">이 페이지를 나가면 변경사항이 저장되지 않습니다.</Text>
        <Flex justify="flex-end" gap={8}>
          <Button border buttonSize="large" onClick={onConfirm}>
            계속 편집
          </Button>
          <Button buttonType="weak" danger buttonSize="large" onClick={onExit}>
            저장하지 않고 나가기
          </Button>
        </Flex>
      </Flex>
    </CommonModal>
  );
};

export default EditConfirmModal;
